import React, { createContext, useState, useContext } from 'react';
import { getFormattedNumber } from '~/components/qng_ui/helpers';

export const formatMoney = (number, acceptZero = true) => {
  return getFormattedNumber(number / 1_000);
  if (!acceptZero && !number) {
    return 0.0;
  }

  const validNumber = parseFloat(number) || 0;

  // Chia cho 1000
  const divided = validNumber / 1000;

  // Làm tròn tối đa 1 chữ số thập phân
  const result = divided.toFixed(1);

  // Tách phần nguyên và phần thập phân
  const parts = result.split('.');

  // Định dạng phần nguyên với dấu phẩy ngăn cách
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Nếu phần thập phân = 0 thì bỏ đi (vd: 12.0 → 12)
  if (parts[1] === '0') {
    return parts[0];
  }

  return parts.join('.');
};

const StateContext = createContext();

const ContextProvider = ({ children }) => {
  const [reload, setReload] = useState(true);
  const [ref, setRef] = useState();
  const [agency, setAgency] = useState(null);

  return (
    <StateContext.Provider
      value={{ reload, setReload, formatMoney, ref, setRef, agency, setAgency }}>
      {children}
    </StateContext.Provider>
  );
};

export default ContextProvider;

export const useStateContext = () => useContext(StateContext);
